import {css} from "styled-components";
import currentTheme from "../../../react-themes/theme";

const theme = currentTheme();

const FormsCss = css`
  .input-light, .input-invisible {
    border: none;
    background-color: white;
    border-radius: 4px;
    height: 40px;
    padding: 10px;
  }

  .input-invisible:focus-visible, .input-invisible:focus {
    outline: none;
  }

  .input-default {
    height: 40px;
    padding: 3px 0;
    border-width: 1px;
    border-style: solid;
    border-radius: ${theme.borderRadius.sm}px;
    border-color: ${theme.colors.farmy.lightgrey};
  }
`;

export default FormsCss;
